module.exports = __webpack_public_path__ + "static/media/post-07.df1ce62b.jpg";